import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { TextLinkCaret as CoreTextLinkCaret } from '@vds-core/buttons';
import { BodyConfig, TypographyConfig } from '@vds/typography';
import { IconData } from '@vds/icons';
import { colors } from '@vds/theme';

var TextLinkCaret = function TextLinkCaret(props) {
  var typescale = TypographyConfig.getTypescale();
  return /*#__PURE__*/React.createElement(CoreTextLinkCaret, _extends({}, props, {
    useIcon: true,
    calculateFontWeight: 700,
    padding: "0",
    hitArea: true,
    hoverState: true,
    focusState: true,
    activeState: true,
    size: "large",
    typescale: typescale,
    fontConfig: BodyConfig,
    iconConfig: IconData,
    colorConfig: colors
  }));
};

export default TextLinkCaret;